export const addQualites = (payload) => {
  return {
    type: "ADD_QUALITES",
    payload: payload,
  };
};
